import { Component, inject } from '@angular/core';
import { PipesModule } from '@digipay/ng-lib-pipes';

import { BaseComponent } from '../../../../../components/core/components/base/base.component';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';

@Component({
  selector: 'app-golrang-bottom-sheet',
  standalone: true,
  imports: [PipesModule, NgxButtonComponent],
  templateUrl: './golrang-bottom-sheet.component.html',
  styleUrl: './golrang-bottom-sheet.component.scss',
})
export class GolrangBottomSheetComponent extends BaseComponent {
  private bottomSheet = inject(NgxBottomSheetService);

  constructor() {
    super();
  }

  close() {
    this.bottomSheet.closeBottomSheet();
  }
}
